import { useEffect, useState } from "react";

import Api from '../services/ContactenosServices'
import { useForm } from "react-hook-form";
import { ParseJwt } from "../../../../core/utils/functions";

export const useContactenos = () => {

    const [loading, setLoading] = useState(false);

    const [data, setData] = useState([]);
    const [user, setUser] = useState();

    const { register, watch, setValue, handleSubmit, reset, formState: { errors } } = useForm();

    /**PAGINADOR */
    const [inicioPagina, setInicioPagina] = useState(0);
    const [finPagina, setFinPagina] = useState(9);
    const [cambioPagina, setCambioPagina] = useState(5);
    const [paginador, setPaginador] = useState([]);
    const [cantPaginas, setCantPaginas] = useState(0);
    const [options, setOptions] = useState({
        limit: 10,
        offset: 0
    })

    const itemsPaginator = (cant) => {
        const num = cant || 1;
        return Array.from({ length: num }, (_, i) => i + 1);
    };

    const cambiarPagina = (limit = 5, currentIndex = 0) => {
        if (currentIndex) {
            const offset = (limit * currentIndex) - limit;

            setOptions(prevOptions => ({ ...prevOptions, offset }));

            let nuevoInicioPagina = currentIndex;

            if (cantPaginas - currentIndex < cambioPagina) {
                nuevoInicioPagina = cantPaginas - (cambioPagina + 1);
            } else if (currentIndex > 1) {
                nuevoInicioPagina = currentIndex - 2;
            }

            if (nuevoInicioPagina <= 1) {
                nuevoInicioPagina = 0;
            }

            setInicioPagina(nuevoInicioPagina);

            if (cantPaginas > 1) {
                let nuevoFinPagina = cantPaginas + 1;
                if (cantPaginas > (cambioPagina + 1)) {
                    nuevoFinPagina = (cambioPagina + 1) + nuevoInicioPagina;
                }
                setFinPagina(nuevoFinPagina);
            }
        }
    };
    /**** */

    const loadDataFormularios = async () => {
        setLoading(true);
        const response = await Api.obtenerFormularios(options);

        if (!response.success) {
            setLoading(false);
            return;
        }

        setData(response.data.datos);
        setPaginador(response.data);
        setCantPaginas(response.data.pages);
        setLoading(false);
    }

    const handdleEstado = async (data) => {
        setLoading(true);

        var response;

        if (data.activo == '1') {
            response = await Api.cambiarEstado(data, '0');
        } else {
            response = await Api.cambiarEstado(data, '1');
        }

        if (!response.success) {
            setLoading(false);
            return;
        }

        setLoading(false);
        loadDataFormularios();
    }

    useEffect(() => {
        const dataUser = ParseJwt(localStorage.getItem('token'));
        setUser(dataUser);

        loadDataFormularios().then();

    }, [options, inicioPagina, finPagina]);


    return {
        state: {
            loading
        },
        data: {
            data
        },
        form: { register, watch, setValue, handleSubmit, errors, reset },
        functions: {
            handdleEstado
        },
        paginador: {
            inicioPagina,
            finPagina,
            cambioPagina,
            paginador,
            cantPaginas,
            options,
            setOptions,
            cambiarPagina,
            itemsPaginator
        },
    };
}